export function createFramebuffer(gl: WebGL2RenderingContext): WebGLFramebuffer {
  const b = gl.createFramebuffer();
  if (b == null) {
    throw Error("failed to create framebuffer");
  }
  return b;
}
